"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownButton = void 0;
var react_1 = __importDefault(require("react"));
var Dropdown_1 = require("./Dropdown");
var Button_1 = require("./Button");
var DropdownButton = function (props) {
    var items = props.items.map(function (item) {
        return item ? { key: item.toLowerCase(), element: item } : Dropdown_1.Separator;
    });
    return (react_1.default.createElement(Dropdown_1.Dropdown, { items: items, onSelect: props.onSelect, alignRight: props.alignRight }, function (dropdownProps) { return (react_1.default.createElement(Button_1.Button, __assign({ color: "white", ref: dropdownProps.toggleRef }, dropdownProps), props.title)); }));
};
exports.DropdownButton = DropdownButton;
